<div class="div__botao__responder">
  <button class="botao__responder">Responder</button>
</div>
